import React from "react";
import "../Instruction/index.scss";
import imgInstru from "../../../../assets/images/Event-2025/title-congra.png";
import bgBotLeft from "../../../../assets/images/Event-2025/img-bot-left.png";
import bgBotRight from "../../../../assets/images/Event-2025/img-bot-right.png";
import CongratulationMain from "./CongratulationMain";

export default function Congratulation({ statusEvent }) {
  return (
    <div className="event-2024-tab-rank">
      <div className="rank_top">
        <div className="rank_top_title title_congra">
          <img src={imgInstru} alt="" />
        </div>
      </div>
      <CongratulationMain isPageCongatulation />
      <div className="bg_bot_left">
        <img src={bgBotLeft} alt="" />
      </div>
      <div className="bg_bot_right">
        <img src={bgBotRight} alt="" />
      </div>
    </div>
  );
}
